import { IKnmResultInfoType } from 'APIPackage/CatalogsModule/interfaces/IKnmResultInfoType';

import { IKnmResultInfoTypeSelectOption } from '../interfaces/IKnmResultInfoTypeSelectOption';

export const createKnmResultInfoTypeSelectOption = (
  knmResultInfoType: IKnmResultInfoType,
): IKnmResultInfoTypeSelectOption => ({
  ...knmResultInfoType,
  label: knmResultInfoType.name,
  value: knmResultInfoType.code,
});
